import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import PVDataTable from './components/PVDataTable.vue'
import PVDataTableAbgabe from './components/PVDataTableAbgabe.vue'
import PVDataTableStundenaufzeichnung from './components/PVDataTableStundenaufzeichnung.vue'
import PVDataTableListenansicht from './components/PVDataTableListenansicht.vue'
import PVDataTableZASumme from './components/PVDataTableZASumme.vue'

const componentMap = {
    PVDataTable,
    PVDataTableAbgabe,
    PVDataTableStundenaufzeichnung,
    PVDataTableListenansicht,
    PVDataTableZASumme
};

const routes = (window.dynamicRoutes || []).map(route => ({
    ...route,
    component: componentMap[route.component] || PVDataTable
}));

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;
createApp(App).use(router).mount('#vue-app');